import { useState } from 'react'

import { performRentalPortalApplicantTransition } from '../../../../../../../api'
import { isApiConflictStatus } from '../../../../../../../utils/api'
import { useApplicantProfileContext } from '../../../../RentalPortalApplicantProfile.hooks'
import { ApplicantDecisionModal } from '../../ApplicantDecisionModal'
import { APPLICANT_DECISION_TRANSITION_ACTION } from '../../ApplicantDecisionPanel.constants'
import {
  getApplicantDecisionConflictKey,
  getApplicantDecisionCurrentConflictKey,
} from '../../ApplicantDecisionPanel.utils'

export function useApplicantDecisionActions() {
  const {
    applicantData,
    applicantId,
    handleCloseModal,
    handleEntityReload,
    setModal,
  } = useApplicantProfileContext()

  const [conflict, setConflict] = useState(null)

  async function submitDecision({ action, note }) {
    setConflict(null)

    try {
      await performRentalPortalApplicantTransition({
        action: APPLICANT_DECISION_TRANSITION_ACTION[action],
        data: { note },
        id: applicantId,
      })
    } catch (error) {
      if (!isApiConflictStatus(error?.response?.status)) {
        throw error
      }

      setConflict({ applicantId, key: getApplicantDecisionConflictKey(error) })
    }

    handleCloseModal()

    await handleEntityReload()
  }

  function handleClickAction(action) {
    setConflict(null)

    setModal(
      <ApplicantDecisionModal
        action={action}
        applicantData={applicantData}
        onClose={handleCloseModal}
        onSubmit={note => submitDecision({ action, note })}
      />
    )
  }

  return {
    conflictKey: getApplicantDecisionCurrentConflictKey({
      applicantId,
      conflict,
    }),
    handleClickAction,
  }
}
